
    // import axios from 'axios';
   
    import React, { Suspense } from "react";
    import { useGLTF , Stage} from "@react-three/drei";
    import { Canvas } from '@react-three/fiber';
    import {  PresentationControls, Environment, ContactShadows } from '@react-three/drei';
    import { useState, useEffect} from "react";
    import { getMarketNftsLiveById } from "../../utils/wallet"
import LoaderGlb from "../loaderGlb/LoaderGlb";
   
    
    const Model = (glbPath) => {
      console.log(glbPath.glbPath)
      const { scene } = useGLTF(glbPath.glbPath);
      return <primitive object={scene} />;
    }
    
    // const Card = (props) => {
    //     // const { item } = props;
    //     //console.log(props);
        
    //     const name = props.itemData.name;
    //     const description = props.itemData.description;
    //     const glbPath = props.itemData.glbPath;
    //     //const url = '/tim.jpg';

    //     // const { name, description, glbPath } = props;
    //     console.log('description',description);
    //     console.log('glbPath',glbPath);
        
    //     return (
    //         <div className="col">
    //             <div className="card" style={{height: '80vh',width: '100%'}}>
    //                 <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 1], fov: 50 }}>
    //                     <ambientLight intensity={0.5} />
    //                     <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} shadow-mapSize={[512, 512]} castShadow />
    //                     <PresentationControls
    //                         global
    //                         config={{ mass: 2, tension: 500 }}
    //                         snap={{ mass: 4, tension: 1500 }}
    //                         rotation={[0, 0.3, 0]}
    //                         polar={[-Math.PI / 3, Math.PI / 3]}
    //                         azimuth={[-Math.PI / 1.4, Math.PI / 2]}>
    //                             <Stage preset="rembrandt" intensity={1} environment="city">
    //                             <Suspense fallback={null}>
    //                         <Model glbPath={'./PlayerNFT.glb'}/>
    //                         </Suspense>
    //                         </Stage>
    //                     </PresentationControls>
    //                     <ContactShadows rotation-x={Math.PI / 2} position={[0, -1.4, 0]} opacity={0.75} width={10} height={10} blur={2.6} far={2} />
    //                     <Environment preset="city" />
    //                 </Canvas>
    //                 <div className="card-body">
    //                     <h5 className="card-title">{name}</h5>
    //                     <p className="card-text">{description}</p>  
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // };
    
    const MarketItem1 = ({ itemId }) => {
        const [loading, setLoading] = useState(true);

        // const { size, camera } = useThree()
        // const controls = useControls()

        const [item, setItem] = useState({
            name: 'Loading...',
            description: 'Loading...',
            glbPath: '',
            url: ''
        });

        useEffect(() => {
            const func = async () => {
                try  {
                    const props = await getMarketNftsLiveById(itemId);
                    console.log(props);
                    setItem(props);
                    setLoading(false);
                } catch (err) {
                    console.log(err);
                    setLoading(false);
                }
            }
            func();
        }, [itemId]);
        return (
            <div>




                <div className="row row-cols-1 row-cols-md-3 g-4" style={{background:'black'}}>
                {loading  ? <div style={{width:'100%', height:'2000px', background:'transparent'}}>
                    <div className='centerLoader'>
                    <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                    </div>
                    </div>
                    :<>
                    <div className="col-md-8 offset-md-2" style={{background:'transparent', marginTop:"180px"}}>
                    
                    {/* <Card itemData={item} /> */}

                        <div className="col">
                            <div className="card" style={{height: '80vh',width: '100%'}}>
                                <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 1], fov: 50 }}>
                                <Suspense fallback={<LoaderGlb />}>
                                    <ambientLight intensity={0.5} />
                                    <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} shadow-mapSize={[512, 512]} castShadow />
                                    <PresentationControls
                                        global
                                        config={{ mass: 2, tension: 500 }}
                                        snap={{ mass: 4, tension: 1500 }}
                                        rotation={[0, 0.3, 0]}
                                        polar={[-Math.PI / 3, Math.PI / 3]}
                                        azimuth={[-Math.PI / 1.4, Math.PI / 2]}>
                                            <Stage preset="rembrandt" intensity={1} environment="city">
                                        
                                        <Model glbPath={item.glbPath}/>
                                    
                                        </Stage>
                                    </PresentationControls>
                                    <ContactShadows rotation-x={Math.PI / 2} position={[0, -1.4, 0]} opacity={0.75} width={10} height={10} blur={2.6} far={2} />
                                    <Environment preset="city" />
                                    </Suspense>
                                </Canvas>
                                <div className="card-body">
                                    <h5 className="card-title">{item.name}</h5>
                                    <p className="card-text">{item.description}</p>  
                                </div>
                            </div>
                        </div>
                    
                    </div>
                    </>}
                </div>
            </div>
           
        );
    };
    
    export default MarketItem1;
    